// Some description fields from the API come back with literal backslash
// escape sequences baked into the text (e.g. the raw characters `\r\n`, not
// an actual line break) and escaped quotes (`\"`) — a backend double-encoding
// issue, not real formatting. Rendered as-is via dangerouslySetInnerHTML,
// these show up as visible garbage in the middle of sentences.
export const cleanDescription = (html) => {
    if (!html) return html;
    return String(html)
        .replace(/\\r\\n/g, '<br/>')
        .replace(/\\n/g, '<br/>')
        .replace(/\\r/g, '<br/>')
        .replace(/\\"/g, '"')
        .replace(/\\'/g, "'");
};
